import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const GridSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default GridSVG;
